import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import { FormikProps } from 'formik';
import { IInterventionsChecklist } from '../../../../interfaces/interventions.interface';
import { Switch, Tooltip } from '../../../../components';
import ServiceSectionLayout from '../../ServiceSectionLayout/ServiceSectionLayout';
import styles from './InterventionsChecklist.styles';
import useStyles from './InterventionsChecklist.styles';

interface IProps {
  testid: string;
  title: string | React.ReactElement;
  form: FormikProps<IInterventionsChecklist>;
  options: {
    title: string;
    formId: string;
    tooltip?: string | React.ReactElement;
  }[];
}

const Interventions: FunctionComponent<IProps> = ({
  testid,
  title,
  form,
  options,
}) => {
  const classes = useStyles();
  return (
    <ServiceSectionLayout
      testId={testid}
      customClass={classes.container}
      title={title}
    >
      {options.map((intervention, idx) => (
        <div
          key={intervention.formId}
          className={cx(classes.switchWrapper, {
            [classes.lastItem]: idx === options.length - 1,
          })}
          style={{display:'flex'}}
        >
          <Switch
            id={intervention.formId}
            checked={form.values[intervention.formId]}
            onChange={form.handleChange}
            label={intervention.title}
          />
          {intervention.tooltip &&
          <Tooltip
            id={`${intervention.formId}__switch-tooltip`}
            title={intervention.tooltip}
            placement="right"
          >
           {}
          </Tooltip>}
        </div>
      ))}
    </ServiceSectionLayout>
  );
};

export default Interventions;
